var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stap-header lichtblauwbg width100"},[_c('div',{staticClass:"fontsize14 bold midblauw padding10 uppercase"},[_vm._v(" Stap "+_vm._s(_vm.step)+": "+_vm._s(_vm.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }